import { PillStateType, } from '@kubit/web-ui-components/pill/types';
import { FONT_WEIGHT } from '../../../foundations/typography';
import { TextVariantType } from '../../variants';
import { KubitPillSizeType } from '../variants';
const buildCommonProps = (FOUNDATIONS, FONT) => ({
    rootContainer: {
        position: 'relative',
        display: 'flex',
        flex_direction: 'column',
        align_items: 'center',
        border_radius: FOUNDATIONS.radius_1000,
    },
    input: {
        position: 'absolute',
        top: '0',
        left: '0',
        right: '0',
        bottom: '0',
        cursor: 'pointer',
        // these width and height are needed for iOS to make the input cover the entire area of the component
        // otherwise the input will be smaller than the component
        width: '100%',
        height: '100%',
        border_radius: FOUNDATIONS.radius_1000,
    },
    contentContainer: {
        display: 'flex',
        flex_direction: 'row',
        align_items: 'center',
        gap: FOUNDATIONS.spacing_150,
        padding: `${FOUNDATIONS.spacing_150} ${FOUNDATIONS.spacing_250}`,
        background_color: FOUNDATIONS.color_comp_forms_pill_unselected_bg,
        border_radius: FOUNDATIONS.radius_comp_forms_pill_radiussize,
        border: `${FOUNDATIONS.border_50} solid ${FOUNDATIONS.color_comp_forms_pill_unselected_border}`,
        cursor: 'pointer',
    },
    leftIcon: {
        color: FOUNDATIONS.color_comp_forms_pill_unselected_icon,
        height: FOUNDATIONS.size_250,
        width: FOUNDATIONS.size_250,
    },
    label: {
        font_variant: TextVariantType.FONT_PARAGRAPH_350,
        font_weight: FONT_WEIGHT.font_regular,
        color: FOUNDATIONS.color_comp_forms_pill_unselected_font,
        word_break: 'break-all',
    },
    rightIcon: {
        color: FOUNDATIONS.color_comp_forms_pill_unselected_icon,
        height: FOUNDATIONS.size_250,
        width: FOUNDATIONS.size_250,
    },
});
export const getKubitPillRegularStyles = (FOUNDATIONS, FONT) => {
    const commonProps = buildCommonProps(FOUNDATIONS, FONT);
    return {
        [KubitPillSizeType.DEFAULT]: {
            [PillStateType.DEFAULT]: { ...commonProps },
            [PillStateType.SELECTED]: {
                ...commonProps,
                contentContainer: {
                    ...commonProps.contentContainer,
                    background_color: FOUNDATIONS.color_comp_forms_pill_selected_bg,
                    border: `${FOUNDATIONS.border_50} solid ${FOUNDATIONS.color_comp_forms_pill_selected_border}`,
                },
                leftIcon: {
                    ...commonProps.leftIcon,
                    color: FOUNDATIONS.color_comp_forms_pill_selected_icon,
                },
                label: {
                    ...commonProps.label,
                    font_weight: FONT_WEIGHT.font_weight_600,
                    color: FOUNDATIONS.color_accent_selected_onselected_font_50,
                },
                rightIcon: {
                    ...commonProps.rightIcon,
                    color: FOUNDATIONS.color_comp_forms_pill_selected_icon,
                },
            },
            [PillStateType.DISABLED]: {
                ...commonProps,
                input: {
                    ...commonProps.input,
                    cursor: 'auto',
                },
                contentContainer: {
                    ...commonProps.contentContainer,
                    background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                    border: `${FOUNDATIONS.border_50} solid ${FOUNDATIONS.color_accent_disabled_border_100}`,
                    cursor: 'auto',
                },
                leftIcon: {
                    ...commonProps.leftIcon,
                    color: FOUNDATIONS.color_accent_disabled_icon_100,
                },
                label: {
                    ...commonProps.label,
                    color: FOUNDATIONS.color_accent_disabled_font_100,
                },
                rightIcon: {
                    ...commonProps.rightIcon,
                    color: FOUNDATIONS.color_accent_disabled_icon_100,
                },
            },
            [PillStateType.DISABLED_SELECTED]: {
                ...commonProps,
                input: {
                    ...commonProps.input,
                    cursor: 'auto',
                },
                contentContainer: {
                    ...commonProps.contentContainer,
                    background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                    border: `${FOUNDATIONS.border_50} solid ${FOUNDATIONS.color_accent_disabled_bg_100}`,
                    cursor: 'auto',
                },
                leftIcon: {
                    ...commonProps.leftIcon,
                    color: FOUNDATIONS.color_accent_disabled_icon_50,
                },
                label: {
                    ...commonProps.label,
                    font_weight: FONT_WEIGHT.font_weight_600,
                    color: FOUNDATIONS.color_accent_disabled_font_50,
                },
                rightIcon: {
                    ...commonProps.rightIcon,
                    color: FOUNDATIONS.color_accent_disabled_icon_50,
                },
            },
        },
    };
};
//# sourceMappingURL=regular.js.map